<template>
  <div v-if="hasError" class="input-error">
    <slot />
  </div>
</template>

<script>
export default {
  name: "BaseValidationError",
  props: {
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
